import React from "react";
import { useParams } from "react-router-dom";
import Annotation from "./Annotation";
import Adjudication from "./Adjudication";

function WaveformSegmentPartial() {
  const params = useParams();
  return (
    <>
      {params.role === "adjudicator" ? (
        <Adjudication pid={parseInt(params.pid, 10)} />
      ) : (
        <Annotation pid={parseInt(params.pid, 10)} />
      )}
    </>
  );
}
export default WaveformSegmentPartial;
